import React from "react";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import Embers from "./Embers";
import { IMAGES, APPLY_URL } from "../../data/mock";

export default function FinalCTA() {
  return (
    <section id="final" className="relative py-32 md:py-48 overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.silhouetteEmber} alt="" className="w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0" style={{ background: "radial-gradient(900px 500px at 50% 60%, rgba(201,114,42,0.22), transparent 60%), linear-gradient(180deg, rgba(10,9,8,0.6) 0%, rgba(10,9,8,0.95) 100%)" }}></div>
        <Embers density={70} />
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 md:px-10 text-center">
        <div className="font-mono text-[10px] uppercase tracking-[0.32em] text-[var(--ember-3)] mb-8">— Brother, the door is open. —</div>
        <Reveal>
          <h2 className="font-display text-[52px] md:text-[110px] leading-[0.94] tracking-[-0.03em]">
            Become the man<br /> your family <span className="italic-serif text-[var(--ember-3)]">needs</span>.
          </h2>
        </Reveal>
        <Reveal delay={150}>
          <p className="mt-10 max-w-[620px] mx-auto text-[var(--text-muted)] text-[17px] leading-[1.75]">
            Twenty-five minutes of honest answers. One conversation with yourself. The man you have been waiting on is on the other side of it.
          </p>
        </Reveal>
        <div className="mt-12 flex flex-col md:flex-row items-center justify-center gap-4">
          <a href={APPLY_URL} target="_blank" rel="noreferrer" className="btn-ember">Begin the Application <ArrowUpRight size={16}/></a>
        </div>
        <div className="mt-8 font-mono text-[11px] uppercase tracking-[0.22em] text-[var(--text-dim)]">Reviewed personally by Coach Colin · 48-hour response · 100% confidential</div>
      </div>
    </section>
  );
}
